import React from "react";
import ListItemIcon from "@mui/material/ListItemIcon";
import Tooltip from "@mui/material/Tooltip";
import StarFullfilledIcon from "@mui/icons-material/Star";
import StarIcon from "@mui/icons-material/StarBorderTwoTone";
import { useDispatch, useSelector } from "react-redux";

import { addFavorite, deleteFavorite } from "../store/ducks/duckFavorites";
import { useUser } from "../auth/UserProvider";

const FavoriteButton = ({ className, id, hidden }) => {
  const favorite = useSelector((state) => state.favorites.data.find((x) => x.layoutId === id));
  const dispatch = useDispatch();

  const { networkUser } = useUser();
  const handleAdd = (id) => (e) => {
    e.preventDefault();
    let favorite = {
      layoutId: id,
      networkUser,
    };

    dispatch(addFavorite(favorite));
  };

  const handleRemove = (id) => (e) => {
    e.preventDefault();
    dispatch(deleteFavorite(id));
  };

  return (
    <ListItemIcon hidden={hidden}>
      {favorite ? (
        <Tooltip title={"Remove Favorite"}>
          <StarFullfilledIcon className={className} onClick={handleRemove(favorite.id)} />
        </Tooltip>
      ) : (
        <Tooltip title={"Add Favorite"}>
          <StarIcon className={className} onClick={handleAdd(id)} />
        </Tooltip>
      )}
    </ListItemIcon>
  );
};

export default FavoriteButton;
